<template>
  <div class="validate-animation">
    <span class="validate-animation__title">Validering</span>
  </div>
</template>
<script>
export default {
  name: 'validateAnimation',
  props: {
    view: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
@import '../styles/settings';
.validate-animation {
  height: 70px;
  position: relative;
  display: none;
  &:before {
    content: '';
    position: absolute;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: get-color(byas-primary);
  }
  // Title
  &__title {
    font-size: 1.5rem;
    line-height: 70px;
    text-align: center;
    color: #fff;
    width: 100%;
    display: block;
    position: relative;
    font-family: 'Source Sans Pro', sans-serif;
  }
}
</style>